<template>
  <div class="international-targets industry-targets">
    <p class="app-step-two-tabs-targeting-tabs__descr">
      This is an optional Direct-to-Journalist custom distribution. It is in
      addition to the standard USA National distribution.
      <span
        >Additional countries are available at
        {{ internationalDistributionPrice }} each, or all available countries
        for {{ internationalDistributionAllPrice }}</span
      >
    </p>
    <targeting-list
      :selected-items="selectedItems"
      :resource-url="API.getDistributionCountriesResource"
      :restrict-selection="false"
      :add-all-button="true"
      payload-key-name="countries"
    >
    </targeting-list>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useOrder } from '@core/composables/order/useOrder'

import API from '@core/api'
import TargetingList from '@modules/app-steps/step-two/tabs/targeting/targeting-list/index.vue'
import { formatPrice } from '@core/utils/price'

const { order } = useOrder()
const selectedItems = computed(
  () => order?.value?.internationalDistributionCountries ?? []
)

const internationalDistributionAllPrice = computed(() =>
  formatPrice(
    order?.value?.packagePrice?.package?.internationalDistributionAllPrice
  )
)
const internationalDistributionPrice = computed(() =>
  formatPrice(
    order?.value?.packagePrice?.package?.internationalDistributionPrice
  )
)
</script>
